export const CATEGORY='filter/category'
export const AUTHOR='filter/author'
export const QUERY='filter/query'
export const ALLBLOGS='filter/allblogs'